<script setup>
import { computed, inject } from 'vue';
import { flowThreadContextKey } from './flowThreadContext';
import NodeInlineField from '../ui/NodeInlineField.vue';

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const context = inject(flowThreadContextKey);
const hasTitleValue = computed(() =>
  Boolean(props.node.config?.title?.trim?.())
);
</script>

<template>
  <div
    class="bg-[linear-gradient(135deg,rgba(248,250,252,1),rgba(241,245,249,0.9))] px-3 py-2.5"
  >
    <div
      class="text-[10px] font-semibold uppercase tracking-wide text-n-slate-10"
    >
      {{ node.type }}
    </div>
    <NodeInlineField
      v-if="isSelected"
      :model-value="node.config?.title || ''"
      :placeholder="node.label"
      variant="plain"
      @update:model-value="context.updateNode({ title: $event })"
    />
    <div
      v-else
      class="mt-1.5 text-[12px] font-medium"
      :class="hasTitleValue ? 'text-n-slate-12' : 'text-n-slate-9'"
    >
      {{ node.config?.title || node.label }}
    </div>
  </div>
</template>
